import $ from 'jquery';
import _ from 'underscore';
import BaseView from '../../core/baseView';
import { get as t } from '../../../home24/core/translation';
import * as config from '../../../home24/core/config';
import * as lightbox from '../../../home24/helpers/lightbox';
import Step2ImageNotificationView from './Step2ImageNotificationView';
export default BaseView.extend({
  events: {
    submit: 'onSubmit'
  },

  articleViews: null,
  commentView: null,

  messageBox: null,

  initialize: function(options) {
    this.articleViews = options.articleViews;
    this.messageBox = options.messageBox;
    this.commentView = options.commentView;
  },

  submitForm: function() {
    this.$el.submit();
  },

  onSubmit: function() {
    var isValid = this.isValid();

    if (!this.model.get('b2bCancellationValid')) {
      lightbox
        .setConfig({
          $dialog: $('.js-b2b-order-cancellation'),
          className: 'b2b-order-cancellation'
        })
        .open();

      return false;
    }

    if (isValid && !this.model.get('imagesValid')) {
      new Step2ImageNotificationView({
        $form: this.$el
      });

      return false;
    }

    return isValid;
  },

  /**
   * Method checks if all required fields are filled with proper data before form is submitted
   * @return {bool}
   */
  isValid: function() {
    /*
        Validate comments view
         */
    this.commentView.validate();

    this.model.set({
      imagesValid: true,
      selectsValid: true,
      b2bCancellationValid: true
    });

    /*
        Validate each article view
         */
    _.each(this.articleViews, function(view) {
      view.validateSelects();
      view.validateImages();
    });

    this.messageBox.clear();

    if (!this.model.get('selectsValid')) {
      this.messageBox.addError(t('orderItem.categoryIsRequired.message'));
    }

    if (!this.model.get('commentFieldValid')) {
      this.messageBox.addError(
        t('ui.input.validation.standardMessages.maxLength').replace(
          '%value%',
          config.get('fttc2.validation.comment.maxLength')
        )
      );
    }

    this.messageBox.render();

    return (
      this.model.get('commentFieldValid') && this.model.get('selectsValid')
    );
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step2Controller.js
 **/